/* AnimePPL Storefront — Horizon-Compatible Mega Menu
   Upload to: Assets/mega-menu.js
   Updated: 2026-05-27 — +10 new IP tags, 3-tier brand hierarchy, yellow-circle arrows, full mobile brand list
*/

(() => {

  var INK    = 'var(--ink,#1A1A1F)';
  var PAPER  = 'var(--paper,#F5F1E6)';
  var RED    = 'var(--red,#C94A3F)';
  var YELLOW = 'var(--yellow,#E8C758)';
  var BLUE   = 'var(--blue,#3B5BDB)';

  var IP_TAGS = [
    { name: '星球大戰', theme: 'mecha', handle: '%E6%98%9F%E7%90%83%E5%A4%A7%E6%88%B0' },
    { name: '哥斯拉', theme: 'mecha', handle: '%E5%93%A5%E6%96%AF%E6%8B%89' },
    { name: '幪面超人古迦', theme: 'robot', handle: '%E5%B9%AA%E9%9D%A2%E8%B6%85%E4%BA%BA%E5%8F%A4%E8%BF%A6' },
    { name: '幪面超人亞極陀', theme: 'robot', handle: '%E5%B9%AA%E9%9D%A2%E8%B6%85%E4%BA%BA%E4%BA%9E%E6%A5%B5%E9%99%80' },
    { name: '幪面超人Gotchard', theme: 'robot', handle: '%E5%B9%AA%E9%9D%A2%E8%B6%85%E4%BA%BAgotchard' },
    { name: '超宇宙刑事卡邦', theme: 'robot', handle: '%E8%B6%85%E5%AE%87%E5%AE%99%E5%88%91%E4%BA%8B%E5%8D%A1%E9%82%A6' },
    { name: 'Sanrio', theme: 'comedy', handle: 'sanrio' },
    { name: '海綿寶寶', theme: 'comedy', handle: '%E6%B5%B7%E7%B6%BF%E5%AF%B6%E5%AF%B6' },
    { name: '生物大圖鑑', theme: 'other', handle: '%E7%94%9F%E7%89%A9%E5%A4%A7%E5%9C%96%E9%91%91' },
    { name: 'PIKMIN', theme: 'game', handle: 'pikmin' },
    { name: '超級瑪利奧', theme: 'game', handle: '%E8%B6%85%E7%B4%9A%E7%91%AA%E5%88%A9%E5%A5%A7' },
    { name: '小魔女DoReMi', theme: 'comedy', handle: '%E5%B0%8F%E9%AD%94%E5%A5%B3doremi' },
    { name: '一風堂 Ippudo', theme: 'other', handle: '%E4%B8%80%E9%A2%A8%E5%A0%82-ippudo' },
    { name: '蝙蝠俠', theme: 'robot', handle: '%E8%9D%99%E8%9D%A0%E4%BF%A0' },
    { name: '變種特工', theme: 'robot', handle: '%E8%AE%8A%E7%A8%AE%E7%89%B9%E5%B7%A5' },
    { name: '樂一通', theme: 'comedy', handle: '%E6%A8%82%E4%B8%80%E9%80%9A' },
    { name: '湯姆與謝利', theme: 'comedy', handle: '%E6%B9%AF%E5%A7%86%E8%88%87%E8%AC%9D%E5%88%A9' },
    { name: '阿森一族', theme: 'comedy', handle: '%E9%98%BF%E6%A3%AE%E4%B8%80%E6%97%8F' },
    { name: '小馬寶莉', theme: 'comedy', handle: '%E5%B0%8F%E9%A6%AC%E5%AF%B6%E8%8E%89' },
    { name: '電馭叛客', theme: 'game', handle: '%E9%9B%BB%E9%A6%AD%E5%8F%9B%E5%AE%A2' },
    { name: '鬼滅之刃', theme: 'shonen', handle: '%E9%AC%BC%E6%BB%85%E4%B9%8B%E5%88%83' },
    { name: '海賊王', theme: 'shonen', handle: '%E6%B5%B7%E8%B3%8A%E7%8E%8B' },
    { name: '龍珠', theme: 'shonen', handle: '%E9%BE%8D%E7%8F%A0' },
    { name: '鏈鋸人', theme: 'shonen', handle: '%E9%8F%88%E9%8B%B8%E4%BA%BA' },
    { name: 'Jojo 的奇妙冒險', theme: 'shonen', handle: 'jojo%E7%9A%84%E5%A5%87%E5%A6%99%E5%86%92%E9%9A%AA' },
    { name: '魔導少年/妖精的尾巴', theme: 'shonen', handle: '%E9%AD%94%E5%B0%8E%E5%B0%91%E5%B9%B4-%E5%A6%96%E7%B2%BE%E7%9A%84%E5%B0%BE%E5%B7%B4' },
    { name: '火影忍者', theme: 'shonen', handle: '%E7%81%AB%E5%BD%B1%E5%BF%8D%E8%80%85' },
    { name: '咒術迴戰', theme: 'shonen', handle: '%E5%92%92%E8%A1%93%E8%BF%B4%E6%88%B0' },
    { name: '我的英雄學院', theme: 'shonen', handle: '%E6%88%91%E7%9A%84%E8%8B%B1%E9%9B%84%E5%AD%B8%E9%99%A2' },
    { name: '薩爾達傳說', theme: 'game', handle: '%E8%96%A9%E7%88%BE%E9%81%94%E5%82%B3%E8%AA%AA' },
    { name: '流浪神差', theme: 'shonen', handle: '%E6%B5%81%E6%B5%AA%E7%A5%9E%E5%B7%AE' },
    { name: '星之卡比', theme: 'game', handle: '%E6%98%9F%E4%B9%8B%E5%8D%A1%E6%AF%94' },
    { name: 'BanG Dream!', theme: 'comedy', handle: 'bang-dream' },
    { name: 'SPY×FAMILY 間諜家家酒', theme: 'comedy', handle: 'spy-family-%E9%96%93%E8%AB%9C%E5%AE%B6%E5%AE%B6%E9%85%92' },
    { name: 'Overlord', theme: 'fantasy', handle: 'overlord' },
    { name: 'Lycoris Recoil 莉可麗絲', theme: 'comedy', handle: 'lycoris-recoil-%E8%8E%89%E5%8F%AF%E9%BA%97%E7%B5%B2' },
    { name: '約會大作戰', theme: 'romance', handle: '%E7%B4%84%E6%9C%83%E5%A4%A7%E4%BD%9C%E6%88%B0' },
    { name: '勇氣爆發 Bang Bravern', theme: 'mecha', handle: '%E5%8B%87%E6%B0%A3%E7%88%86%E7%99%BC-bang-bravern' },
    { name: '勝利女神：妮姬', theme: 'game', handle: '%E5%8B%9D%E5%88%A9%E5%A5%B3%E7%A5%9E-%E5%A6%AE%E5%A7%AC' },
    { name: '天元突破紅蓮螺巖', theme: 'mecha', handle: '%E5%A4%A9%E5%85%83%E7%AA%81%E7%A0%B4%E7%B4%85%E8%93%AE%E8%9E%BA%E5%B7%96' },
    { name: '新世紀福音戰士', theme: 'mecha', handle: '%E6%96%B0%E4%B8%96%E7%B4%80%E7%A6%8F%E9%9F%B3%E6%88%B0%E5%A3%AB' },
    { name: '異度神劍 Xenoblade', theme: 'game', handle: '%E7%95%B0%E5%BA%A6%E7%A5%9E%E5%8A%8D-xenoblade' },
    { name: '明日方舟', theme: 'game', handle: '%E6%98%8E%E6%97%A5%E6%96%B9%E8%88%9F' },
    { name: '天官賜福', theme: 'fantasy', handle: '%E5%A4%A9%E5%AE%98%E8%B3%9C%E7%A6%8F' },
    { name: '黑獸 Kuroinu', theme: 'other', handle: '%E9%BB%91%E7%8D%B8-kuroinu' },
    { name: '街頭霸王', theme: 'game', handle: '%E8%A1%97%E9%A0%AD%E9%9C%B8%E7%8E%8B' },
    { name: '迷宮飯', theme: 'fantasy', handle: '%E8%BF%B7%E5%AE%AE%E9%A3%AF' },
    { name: '賽馬娘 Pretty Derby', theme: 'game', handle: '%E8%B3%BD%E9%A6%AC%E5%A8%98-pretty-derby' },
    { name: '藍色監獄', theme: 'sports', handle: '%E8%97%8D%E8%89%B2%E7%9B%A3%E7%8D%84' },
    { name: '初音未來', theme: 'comedy', handle: '%E5%88%9D%E9%9F%B3%E6%9C%AA%E4%BE%86' },
    { name: '戀上換裝娃娃', theme: 'romance', handle: '%E6%88%80%E4%B8%8A%E6%8F%9B%E8%A3%9D%E5%A8%83%E5%A8%83' },
    { name: '不時輕聲地以俄語遮羞的鄰座艾莉同學', theme: 'romance', handle: '%E4%B8%8D%E6%99%82%E8%BC%95%E8%81%B2%E5%9C%B0%E4%BB%A5%E4%BF%84%E8%AA%9E%E9%81%AE%E7%BE%9E%E7%9A%84%E9%84%B0%E5%BA%A7%E8%89%BE%E8%8E%89%E5%90%8C%E5%AD%B8' },
    { name: '狼與辛香料', theme: 'fantasy', handle: '%E7%8B%BC%E8%88%87%E8%BE%9B%E9%A6%99%E6%96%99' },
    { name: '忍者茶茶丸', theme: 'game', handle: '%E5%BF%8D%E8%80%85%E8%8C%B6%E8%8C%B6%E4%B8%B8' },
    { name: 'POWERDoLLS2', theme: 'game', handle: 'powerdolls2' },
    { name: '哈利波特', theme: 'other', handle: '%E5%93%88%E5%88%A9%E6%B3%A2%E7%89%B9' },
    { name: '光與夜之戀', theme: 'game', handle: '%E5%85%89%E8%88%87%E5%A4%9C%E4%B9%8B%E6%88%80' },
    { name: '機動警察 Patlabor', theme: 'mecha', handle: '%E6%A9%9F%E5%8B%95%E8%AD%A6%E5%AF%9F-patlabor' },
    { name: 'Hololive', theme: 'comedy', handle: 'hololive' },
    { name: '新吊帶襪天使', theme: 'comedy', handle: '%E6%96%B0%E5%90%8A%E5%B8%B6%E8%A5%AA%E5%A4%A9%E4%BD%BF' },
    { name: '排球少年', theme: 'sports', handle: '%E6%8E%92%E7%90%83%E5%B0%91%E5%B9%B4' },
    { name: '少女樂團 吶喊吧', theme: 'comedy', handle: '%E5%B0%91%E5%A5%B3%E6%A8%82%E5%9C%98-%E5%90%B6%E5%96%8A%E5%90%A7' },
    { name: '鹿乃子乃子乃子虎視眈眈', theme: 'comedy', handle: '%E9%B9%BF%E4%B9%83%E5%AD%90%E4%B9%83%E5%AD%90%E4%B9%83%E5%AD%90%E8%99%8E%E8%A6%96%E7%9C%88%E7%9C%88' },
    { name: '文豪Stray Dogs', theme: 'shonen', handle: '%E6%96%87%E8%B1%AAstray-dogs' },
    { name: '家庭教師HITMAN REBORN!', theme: 'shonen', handle: '%E5%AE%B6%E5%BA%AD%E6%95%99%E5%B8%ABhitman-reborn' },
    { name: 'Bunny Suit Planning', theme: 'mecha', handle: 'bunny-suit-planning' },
    { name: 'SSSS.GRIDMAN', theme: 'mecha', handle: 'ssss-gridman' },
    { name: '出包王女', theme: 'romance', handle: '%E5%87%BA%E5%8C%85%E7%8E%8B%E5%A5%B3' },
    { name: '科學超電磁砲', theme: 'shonen', handle: '%E7%A7%91%E5%AD%B8%E8%B6%85%E9%9B%BB%E7%A3%81%E7%A0%B2' },
    { name: '太鼓之達人', theme: 'game', handle: '%E5%A4%AA%E9%BC%93%E4%B9%8B%E9%81%94%E4%BA%BA' },
    { name: '魔女之旅', theme: 'fantasy', handle: '%E9%AD%94%E5%A5%B3%E4%B9%8B%E6%97%85' },
    { name: '無職轉生', theme: 'fantasy', handle: '%E7%84%A1%E8%81%B7%E8%BD%89%E7%94%9F' },
    { name: '五等分花嫁', theme: 'romance', handle: '%E4%BA%94%E7%AD%89%E5%88%86%E8%8A%B1%E5%AB%81' },
    { name: '勇者特急隊', theme: 'mecha', handle: '勇者特急隊' },
    { name: '30分鐘幻想戰記', theme: 'mecha', handle: '30%E5%88%86%E9%90%98%E5%B9%BB%E6%83%B3%E6%88%B0%E8%A8%98' },
    { name: '機動戰士高達', theme: 'mecha', handle: '%E6%A9%9F%E5%8B%95%E6%88%B0%E5%A3%AB%E9%AB%98%E9%81%94' },
  ];

  var THEMES = {
    other:   '%E5%85%B6%E4%BB%96',
    shonen:   '%E7%86%B1%E8%A1%80-%E5%B0%91%E5%B9%B4',
    mecha:   '%E6%A9%9F%E7%94%B2-%E7%A7%91%E5%B9%BB',
    robot:   '%E6%A9%9F%E5%99%A8%E4%BA%BA-%E8%B6%85%E7%B4%9A%E8%8B%B1%E9%9B%84',
    sports:   '%E9%81%8B%E5%8B%95',
    fantasy:   '%E5%A5%87%E5%B9%BB-%E7%95%B0%E4%B8%96%E7%95%8C',
    horror:   '%E6%81%90%E6%80%96-%E6%87%B8%E7%96%91',
    romance:   '%E6%84%9B%E6%83%85-%E6%A0%A1%E5%9C%92',
    comedy:   '%E6%90%9E%E7%AC%91-%E6%97%A5%E5%B8%B8',
    game:   '%E9%9B%BB%E7%AB%B6-%E9%81%8A%E6%88%B2',
  };

  var BRAND_DATA = [
    {
      region: 'JAPAN · 日本',
      makers: [
        {
          name: 'BANDAI / 萬代', handle: 'bandai',
          subs: [
            { name: '30 Minutes',  handle: '30-minutes' },
            { name: 'Action Base', handle: 'action-base' },
            { name: 'Gunpla',      handle: 'gunpla' },
          ]
        },
        {
          name: 'Good Smile Company', handle: 'good-smile-company',
          subs: [
            { name: 'Figma',               handle: 'figma' },
            { name: '黏土人 Nendoroid',     handle: '%E9%BB%8F%E5%9C%9F%E4%BA%BA' },
            { name: 'POP UP PARADE',        handle: 'pop-up-parade' },
            { name: 'HELLO! GOOD SMILE',    handle: 'hello-good-smile' },
            { name: 'Huggy Good Smile',     handle: 'huggy-good-smile' },
            { name: 'MODEROID',             handle: 'moderoid' },
            { name: 'Max Factory',          handle: 'max-factory' },
          ]
        },
        {
          name: 'Bushiroad Creative', handle: 'bushiroad-creative',
          subs: [
            { name: 'Pingurumi',  handle: 'pingurumi' },
            { name: 'Puchish!',   handle: 'puchish' },
          ]
        },
        { name: 'KOTOBUKIYA / 壽屋', handle: 'kotobukiya', subs: [] },
        { name: 'MegaHouse',          handle: 'megahouse',  subs: [] },
        { name: 'ALTER',               handle: 'alter',     subs: [] },
        { name: 'Taito（景品）',        handle: 'taito',     subs: [] },
        { name: 'System Service',      handle: 'system-service', subs: [] },
        { name: 'FuRyu',               handle: 'furyu',     subs: [] },
        { name: 'BINDing / Native',    handle: 'binding',   subs: [] },
        { name: 'Aniplex',             handle: 'aniplex',   subs: [] },
        { name: 'Phat!',               handle: 'phat',      subs: [] },
        { name: 'HOTVENUS',            handle: 'hotvenus',  subs: [] },
        { name: 'KADOKAWA',            handle: 'kadokawa',  subs: [] },
        { name: 'DMM Factory',         handle: 'dmm-factory', subs: [] },
        { name: 'PROOF',               handle: 'proof',     subs: [] },
        { name: 'Orange Rouge',        handle: 'orange-rouge', subs: [] },
        { name: 'Spiritale',           handle: 'spiritale', subs: [] },
        { name: 'Plum',                handle: 'plum',      subs: [] },
      ]
    },
    {
      region: 'CHINA · 中國',
      makers: [
        { name: 'POP MART / 泡泡瑪特', handle: 'pop-mart', subs: [] },
        { name: '52TOYS',               handle: '52toys',   subs: [] },
        { name: 'APEX / 工坊',          handle: 'apex',     subs: [] },
      ]
    },
    {
      region: 'WEST · 歐美',
      makers: [
        { name: 'Hot Toys', handle: 'hot-toys', subs: [] },
        { name: 'Funko',    handle: 'funko',    subs: [] },
      ]
    }
  ];

  // Build brand panel HTML
  var _brandCols = BRAND_DATA.map(function(group, gi) {
    var colClass = ['a','b','c'][gi] || 'a';
    var listHtml = '';
    group.makers.forEach(function(maker) {
      if (maker.subs.length) {
        listHtml += '<li class="brand-accordion-head" data-brand-toggle="' + maker.handle + '"><a href="/collections/' + maker.handle + '"><span>' + maker.name + '</span><span class="brand-chev">▸</span></a></li>';
        var subItems = '';
        maker.subs.forEach(function(s) {
          subItems += '<li class="brand-sub"><a href="/collections/' + s.handle + '"><span>' + s.name + '</span></a></li>';
        });
        listHtml += '<ul class="brand-accordion-body" data-brand-maker="' + maker.handle + '">' + subItems + '</ul>';
      } else {
        listHtml += '<li><a href="/collections/' + maker.handle + '"><span>' + maker.name + '</span><span class="arr">→</span></a></li>';
      }
    });
    return '<div class="mega-col ' + colClass + '"><h4>' + group.region + '</h4><ul class="mega-list">' + listHtml + '</ul></div>';
  }).join('\n        ');

  // Build IP sub-items
  var _ipHtml = {};
  IP_TAGS.forEach(function(ip) {
    if (!_ipHtml[ip.theme]) _ipHtml[ip.theme] = '';
    _ipHtml[ip.theme] += '<li class="ip-sub"><a href="/collections/' + ip.handle + '"><span>' + ip.name + '</span></a></li>';
  });
  var sub = function(k) {
    var items = _ipHtml[k] || '';
    if (!items) return '';
    return '<ul class="ip-accordion-body" data-ip-theme="' + k + '">' + items + '</ul>';
  };

  // ── Mega Panel HTML ────────────────────────────────────────────────────────
  var PANELS = {

    products: '<div class="amega-inner">'
      + '<div class="mega-header"><div><div class="mega-eyebrow">DEPT · 01</div><div class="mega-title">產品分類 / Categories</div></div><div class="mega-meta">SHOP BY TYPE</div></div>'
      + '<div class="mega-grid">'
      + '<div class="mega-col a"><h4>手辦 · FIGURES</h4><ul class="mega-list">'
      + '<li><a href="/collections/pvc%E6%89%8B%E8%BE%A6"><span>PVC手辦</span><span class="arr">→</span></a></li>'
      + '<li><a href="/collections/%E5%8F%AF%E5%8B%95%E5%85%AC%E4%BB%94-action-figure"><span>可動公仔 / Action Figure</span><span class="arr">→</span></a></li>'
      + '<li><a href="/collections/q%E7%89%88%E5%85%AC%E4%BB%94-nendoroid"><span>Q版公仔 / Nendoroid</span><span class="arr">→</span></a></li>'
      + '<li><a href="/collections/gk%E5%85%AC%E4%BB%94"><span>GK公仔</span><span class="arr">→</span></a></li>'
      + '</ul></div>'
      + '<div class="mega-col b"><h4>模型 · MODEL KITS</h4><ul class="mega-list">'
      + '<li><a href="/collections/%E9%AB%98%E9%81%94%E6%A8%A1%E5%9E%8B"><span>高達模型</span><span class="arr">→</span></a></li>'
      + '<li><a href="/collections/%E6%AF%94%E4%BE%8B%E6%A8%A1%E5%9E%8B"><span>比例模型</span><span class="arr">→</span></a></li>'
      + '<li><a href="/collections/%E9%A3%9F%E7%8E%A9-%E7%9B%92%E7%8E%A9"><span>食玩 / 盒玩</span><span class="arr">→</span></a></li>'
      + '</ul><h4 style="margin-top:24px">其他 · MISC</h4><ul class="mega-list">'
      + '<li><a href="/collections/%E9%9B%BB%E5%AD%90%E5%AF%B5%E7%89%A9"><span>電子寵物</span><span class="arr">→</span></a></li>'
      + '</ul></div>'
      + '<div class="mega-col c"><h4>周邊類 · GOODS</h4><ul class="mega-list">'
      + '<li><a href="/collections/%E6%8A%B1%E6%9E%95-%E6%AF%9B%E7%B5%A8%E7%8E%A9%E5%85%B7"><span>抱枕 / 毛絨玩具</span><span class="arr">→</span></a></li>'
      + '<li><a href="/collections/%E6%96%87%E5%85%B7-%E7%B2%BE%E5%93%81"><span>文具 / 精品</span><span class="arr">→</span></a></li>'
      + '<li><a href="/collections/%E9%85%8D%E4%BB%B6"><span>配件</span><span class="arr">→</span></a></li>'
      + '<li><a href="/collections/%E6%8E%9B%E4%BB%B6-%E5%BE%BD%E7%AB%A0-%E8%B2%BC%E7%B4%99"><span>掛件 / 徽章 / 貼紙</span><span class="arr">→</span></a></li>'
      + '<li><a href="/collections/%E6%B5%B7%E5%A0%B1-%E6%8E%9B%E8%BB%B8"><span>海報 / 掛軸</span><span class="arr">→</span></a></li>'
      + '</ul></div>'
      + '<div class="mega-feature" style="background:' + INK + '"><div><span class="ft-tag">FEATURED</span><h3 class="ft-title">本月新到貨<br>NEW DROP</h3><div class="ft-sub">NEW ARRIVALS</div></div><a href="/collections/%E6%9C%80%E6%96%B0%E9%A0%90%E8%A8%82" class="ft-cta">立即查看 →</a></div>'
      + '</div></div>',

    ip: '<div class="amega-inner">'
      + '<div class="mega-header"><div><div class="mega-eyebrow">DEPT · 02</div><div class="mega-title">IP系列 / Series</div></div><div class="mega-meta">SHOP BY GENRE</div></div>'
      + '<div class="mega-grid">'
      + '<div class="mega-col a"><h4>動作 · ACTION</h4><ul class="mega-list">'
      + '<li class="ip-accordion-head" data-ip-toggle="shonen"><a href="/pages/shonen"><span>熱血 / 少年</span><span class="ip-chev">▸</span></a></li>'
      + sub('shonen')
      + '<li class="ip-accordion-head" data-ip-toggle="mecha"><a href="/pages/' + THEMES.mecha + '"><span>機甲 / 科幻</span><span class="ip-chev">▸</span></a></li>'
      + sub('mecha')
      + '<li class="ip-accordion-head" data-ip-toggle="robot"><a href="/pages/' + THEMES.robot + '"><span>機器人 / 超級英雄</span><span class="ip-chev">▸</span></a></li>'
      + sub('robot')
      + '<li class="ip-accordion-head" data-ip-toggle="sports"><a href="/pages/' + THEMES.sports + '"><span>運動</span><span class="ip-chev">▸</span></a></li>'
      + sub('sports')
      + '</ul></div>'
      + '<div class="mega-col b"><h4>奇幻 · FANTASY</h4><ul class="mega-list">'
      + '<li class="ip-accordion-head" data-ip-toggle="fantasy"><a href="/pages/' + THEMES.fantasy + '"><span>奇幻 / 異世界</span><span class="ip-chev">▸</span></a></li>'
      + sub('fantasy')
      + '<li class="ip-accordion-head" data-ip-toggle="horror"><a href="/pages/' + THEMES.horror + '"><span>恐怖 / 懸疑</span><span class="ip-chev">▸</span></a></li>'
      + sub('horror')
      + '<li class="ip-accordion-head" data-ip-toggle="romance"><a href="/pages/' + THEMES.romance + '"><span>愛情 / 校園</span><span class="ip-chev">▸</span></a></li>'
      + sub('romance')
      + '</ul></div>'
      + '<div class="mega-col c"><h4>日常 · LIFE</h4><ul class="mega-list">'
      + '<li class="ip-accordion-head" data-ip-toggle="comedy"><a href="/pages/' + THEMES.comedy + '"><span>搞笑 / 日常</span><span class="ip-chev">▸</span></a></li>'
      + sub('comedy')
      + '<li class="ip-accordion-head" data-ip-toggle="game"><a href="/pages/' + THEMES.game + '"><span>電競 / 遊戲</span><span class="ip-chev">▸</span></a></li>'
      + sub('game')
      + '<li class="ip-accordion-head" data-ip-toggle="other"><a href="/pages/' + THEMES.other + '"><span>其他</span><span class="ip-chev">▸</span></a></li>'
      + sub('other')
      + '</ul></div>'
      + '<div class="mega-feature" style="background:' + RED + '"><div><span class="ft-tag" style="background:' + PAPER + ';color:' + INK + '">TRENDING</span><h3 class="ft-title">熱血少年<br>無極限</h3><div class="ft-sub" style="color:rgba(250,246,236,0.7)">TOP 10 · THIS WEEK</div></div><a href="/pages/shonen" class="ft-cta" style="background:' + YELLOW + ';color:' + INK + ';border-color:' + INK + '">睇排行榜 →</a></div>'
      + '</div></div>',

    brand: '<div class="amega-inner" style="max-width:900px">'
      + '<div class="mega-header"><div><div class="mega-eyebrow">DEPT · 03</div><div class="mega-title">品牌 / Brands</div></div><div class="mega-meta">SHOP BY MAKER</div></div>'
      + '<div class="mega-grid" style="grid-template-columns:1fr 1fr 1fr">'
      + _brandCols
      + '</div></div>',

    preorder: '<div class="amega-inner" style="max-width:720px">'
      + '<div class="mega-header"><div><div class="mega-eyebrow">DEPT · 04</div><div class="mega-title">預訂 / Pre-Order</div></div><div class="mega-meta">RESERVE NOW</div></div>'
      + '<div class="mega-grid" style="grid-template-columns:1fr 1fr">'
      + '<div class="mega-col a"><h4>狀態 · STATUS</h4><ul class="mega-list">'
      + '<li><a href="/collections/%E6%9C%80%E6%96%B0%E9%A0%90%E8%A8%82"><span>最新預訂</span><span class="arr">→</span></a></li>'
      + '<li><a href="/collections/%E5%8D%B3%E5%B0%87%E6%88%AA%E8%A8%82"><span>即將截訂</span><span class="arr">→</span></a></li>'
      + '<li><a href="/collections/%E6%9C%80%E6%96%B0%E9%A0%90%E8%A8%82"><span>所有預訂商品</span><span class="arr">→</span></a></li>'
      + '</ul></div>'
      + '<div class="mega-feature" style="background:' + BLUE + ';min-height:220px"><div><span class="ft-tag">DEADLINE</span><h3 class="ft-title" style="font-size:22px">本月截訂<br>倒數 7 天</h3></div><a href="/collections/%E5%8D%B3%E5%B0%87%E6%88%AA%E8%A8%82" class="ft-cta" style="background:' + YELLOW + ';color:' + INK + ';border-color:' + INK + '">即刻預訂 →</a></div>'
      + '</div></div>'
  };

  // ── Styles: Desktop accordion + yellow-circle chevrons ─────────────────────
  var desktopStyle = document.createElement('style');
  desktopStyle.id = 'animeppl-desktop-accordion-css';
  desktopStyle.textContent = [
    '@media (min-width: 750px) {',
    '  .amega-panel { max-height:calc(100vh - 100px); overflow-y:auto; scrollbar-width:thin; scrollbar-color:var(--ink,#1A1A1F) transparent; }',
    '  .amega-panel::-webkit-scrollbar { width:6px; }',
    '  .amega-panel::-webkit-scrollbar-thumb { background:var(--ink,#1A1A1F); border-radius:3px; }',
    '  .amega-panel::-webkit-scrollbar-thumb:hover { background:var(--red,#C94A3F); }',
    /* IP accordion */
    '  .ip-accordion-body { list-style:none; padding:0; margin:0; max-height:0; overflow:hidden; transition:max-height 0.35s cubic-bezier(0.4,0,0.2,1); }',
    '  .ip-accordion-body.ip-acc-open { max-height:600px; }',
    '  .ip-accordion-head .ip-chev { display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; border-radius:50%; background:var(--yellow,#E8C758); color:#fff; font-size:10px; margin-left:8px; transition:transform 0.3s ease; flex-shrink:0; }',
    '  .ip-accordion-head.ip-acc-active .ip-chev { transform:rotate(90deg); }',
    '  .ip-accordion-head.ip-acc-active > a { background:var(--ink,#1A1A1F); color:var(--yellow,#E8C758); padding-left:18px; }',
    '  .ip-accordion-head.ip-acc-active > a .ip-chev { color:#fff; }',
    '  .ip-accordion-body .ip-sub { padding-left:14px!important; margin:1px 0!important; }',
    '  .ip-accordion-body .ip-sub a { font-size:13px!important; opacity:0.65; transition:opacity 0.15s; }',
    '  .ip-accordion-body .ip-sub a:hover { opacity:1; }',
    '  .ip-accordion-body .ip-sub a span::before { content:"· "; font-weight:bold; }',
    /* Brand accordion — identical visual to IP */
    '  .brand-accordion-body { list-style:none; padding:0; margin:0; max-height:0; overflow:hidden; transition:max-height 0.35s cubic-bezier(0.4,0,0.2,1); }',
    '  .brand-accordion-body.brand-acc-open { max-height:400px; }',
    '  .brand-accordion-head .brand-chev { display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; border-radius:50%; background:var(--yellow,#E8C758); color:#fff; font-size:10px; margin-left:8px; transition:transform 0.3s ease; flex-shrink:0; }',
    '  .brand-accordion-head.brand-acc-active .brand-chev { transform:rotate(90deg); }',
    '  .brand-accordion-head.brand-acc-active > a { background:var(--ink,#1A1A1F); color:var(--yellow,#E8C758); padding-left:18px; }',
    '  .brand-accordion-head.brand-acc-active > a .brand-chev { color:#fff; }',
    '  .brand-accordion-body .brand-sub { padding-left:14px!important; margin:1px 0!important; }',
    '  .brand-accordion-body .brand-sub a { font-size:13px!important; opacity:0.65; transition:opacity 0.15s; }',
    '  .brand-accordion-body .brand-sub a:hover { opacity:1; }',
    '  .brand-accordion-body .brand-sub a span::before { content:"· "; font-weight:bold; }',
    '}',
    '@media (max-width: 749px) {',
    '  .ip-accordion-body { max-height:none!important; overflow:visible!important; }',
    '  .brand-accordion-body { max-height:none!important; overflow:visible!important; }',
    '  .ip-chev, .brand-chev { display:none!important; }',
    '}'
  ].join('\n');
  document.head.appendChild(desktopStyle);

  // ── Build floating overlay ─────────────────────────────────────────────────
  var overlay = document.createElement('div');
  overlay.id = 'animeppl-mega-overlay';
  overlay.innerHTML = Object.entries(PANELS).map(function(e) { return '<div class="amega-panel" data-panel="' + e[0] + '">' + e[1] + '</div>'; }).join('');
  document.body.appendChild(overlay);

  // ── Desktop accordion click handler ────────────────────────────────────────
  overlay.addEventListener('click', function(e) {
    if (window.matchMedia('(max-width:749px)').matches) return;
    var headLi = e.target.closest('.ip-accordion-head');
    if (headLi) {
      var tk = headLi.dataset.ipToggle; if (!tk) return;
      var body = headLi.parentElement.querySelector('.ip-accordion-body[data-ip-theme="'+tk+'"]'); if (!body) return;
      var wasOpen = body.classList.contains('ip-acc-open');
      var panel = headLi.closest('[data-panel="ip"]');
      if (panel) { panel.querySelectorAll('.ip-accordion-body.ip-acc-open').forEach(function(b){b.classList.remove('ip-acc-open');}); panel.querySelectorAll('.ip-accordion-head.ip-acc-active').forEach(function(h){h.classList.remove('ip-acc-active');}); }
      if (!wasOpen) { body.classList.add('ip-acc-open'); headLi.classList.add('ip-acc-active'); }
      if (e.target.closest('.ip-chev')) { e.preventDefault(); e.stopPropagation(); }
      return;
    }
    var bh = e.target.closest('.brand-accordion-head');
    if (bh) {
      var mk = bh.dataset.brandToggle; if (!mk) return;
      var body = bh.parentElement.querySelector('.brand-accordion-body[data-brand-maker="'+mk+'"]'); if (!body) return;
      var wasOpen = body.classList.contains('brand-acc-open');
      var panel = bh.closest('[data-panel="brand"]');
      if (panel) { panel.querySelectorAll('.brand-accordion-body.brand-acc-open').forEach(function(b){b.classList.remove('brand-acc-open');}); panel.querySelectorAll('.brand-accordion-head.brand-acc-active').forEach(function(h){h.classList.remove('brand-acc-active');}); }
      if (!wasOpen) { body.classList.add('brand-acc-open'); bh.classList.add('brand-acc-active'); }
      if (e.target.closest('.brand-chev')) { e.preventDefault(); e.stopPropagation(); }
      return;
    }
  });

  // ── Hover/focus state ──────────────────────────────────────────────────────
  var activePanel = null, activeTrigger = null, closeTimer = null;
  var showPanel = function(key, trigger) {
    if (window.matchMedia('(max-width:749px)').matches) return;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    var panel = overlay.querySelector('[data-panel="'+key+'"]'); if (!panel) return;
    if (activePanel && activePanel !== panel) activePanel.classList.remove('amega-visible');
    if (activeTrigger && activeTrigger !== trigger) activeTrigger.classList.remove('amega-trigger-active');
    overlay.style.top = (trigger.getBoundingClientRect().bottom + 2) + 'px';
    panel.scrollTop = 0;
    panel.classList.add('amega-visible'); trigger.classList.add('amega-trigger-active');
    activePanel = panel; activeTrigger = trigger;
  };
  var scheduleHide = function() {
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(function() {
      if (activePanel) activePanel.classList.remove('amega-visible');
      if (activeTrigger) activeTrigger.classList.remove('amega-trigger-active');
      activePanel = null; activeTrigger = null;
    }, 180);
  };
  overlay.addEventListener('mouseenter', function() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } });
  overlay.addEventListener('mouseleave', scheduleHide);
  document.addEventListener('click', function(e) {
    if (!e.target.closest('#animeppl-mega-overlay') && !e.target.closest('[data-amenu]')) {
      if (activePanel) activePanel.classList.remove('amega-visible');
      if (activeTrigger) activeTrigger.classList.remove('amega-trigger-active');
      activePanel = null; activeTrigger = null;
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (activePanel) activePanel.classList.remove('amega-visible');
      if (activeTrigger) activeTrigger.classList.remove('amega-trigger-active');
      activePanel = null; activeTrigger = null;
    }
  });

  // ── Wire nav triggers ──────────────────────────────────────────────────────
  var NAV_MAP = [
    { match: ['產品分類','Products'], key: 'products' },
    { match: ['IP系列','IP Series'],  key: 'ip' },
    { match: ['品牌','Brands'],        key: 'brand' },
    { match: ['預訂','Pre-Order','Preorder','Pre-order'], key: 'preorder' }
  ];
  var wireTriggers = function() {
    var header = document.querySelector('header, .header, [role="banner"]'); if (!header) return;
    var sel = 'nav li a, nav li button, [role="navigation"] li a, [role="navigation"] li button, [class*="menu-nav"] li a, [class*="menu-nav"] li button, [class*="header__menu"] li a, [class*="header__menu"] li button';
    header.querySelectorAll(sel).forEach(function(el) {
      if (el.dataset.amenu) return;
      var text = (el.textContent||'').trim().replace(/\s+/g,'');
      for (var i=0;i<NAV_MAP.length;i++) {
        var item = NAV_MAP[i];
        if (item.match.some(function(m){return text===m.replace(/\s+/g,'');})) {
          el.dataset.amenu = item.key;
          (function(k){ el.addEventListener('mouseenter',function(){showPanel(k,el);}); el.addEventListener('mouseleave',scheduleHide); el.addEventListener('focus',function(){showPanel(k,el);}); })(item.key);
          break;
        }
      }
    });
  };
  if (document.readyState==='loading') { document.addEventListener('DOMContentLoaded',function(){wireTriggers();setTimeout(wireTriggers,600);}); }
  else { wireTriggers(); setTimeout(wireTriggers,600); }

  // ── Cmd/Ctrl+K search ─────────────────────────────────────────────────────
  document.addEventListener('keydown', function(e) {
    if ((e.metaKey||e.ctrlKey) && e.key.toLowerCase()==='k') { e.preventDefault(); var inp=document.querySelector('header input[type="search"], header input[name="q"]'); if(inp) inp.focus(); }
  });

  // ── Scroll Mascot ─────────────────────────────────────────────────────────
  var mascot = document.querySelector('.scroll-mascot');
  if (mascot) {
    window.addEventListener('scroll', function(){mascot.classList.toggle('visible',window.scrollY>300);}, {passive:true});
    mascot.addEventListener('click', function(){window.scrollTo({top:0,behavior:'smooth'});});
  }

  // ── Mobile Drawer Accordion (unified IP + Brand, yellow-circle arrows) ─────
  (function drawerAccordion() {
    var CATEGORY_ORDER = ['產品分類','IP系列','品牌','預訂'];
    var CATEGORY_COLORS = {'產品分類':'#E8C758','IP系列':'#C94A3F','品牌':'#3B5BDB','預訂':'#E8C758'};
    var IP_BY_THEME = {};
    IP_TAGS.forEach(function(t){ if(!IP_BY_THEME[t.theme]) IP_BY_THEME[t.theme]=[]; IP_BY_THEME[t.theme].push(t); });
    var HANDLE_TO_THEME = {};
    for(var k in THEMES){ HANDLE_TO_THEME[THEMES[k]]=k; }
    HANDLE_TO_THEME['shonen']='shonen';

    function injectStyles() {
      if(document.getElementById('animeppl-drawer-accordion-css')) return;
      var style=document.createElement('style');
      style.id='animeppl-drawer-accordion-css';
      var colorRules=[];
      CATEGORY_ORDER.forEach(function(cat,i){ colorRules.push('.menu-drawer__list-item--flat:nth-child('+(i+1)+'){--drawer-cat-color:'+CATEGORY_COLORS[cat]+'}'); });
      style.textContent = [
        '@media(max-width:749px){#animeppl-mega-overlay{display:none!important}}',
        colorRules.join('\n'),
        '.menu-drawer__list-item--flat{border-left:4px solid var(--drawer-cat-color,#E8C758);padding-left:12px!important;margin-bottom:4px;}',
        '.menu-drawer__list-item--flat > ul{max-height:0!important;overflow:hidden!important;transition:max-height .35s cubic-bezier(.4,0,.2,1);}',
        '.menu-drawer__list-item--flat.drawer-open > ul{max-height:2000px!important;}',
        '.menu-drawer__list-item--flat > ul > li > a{justify-content:flex-start!important;gap:0!important;}',
        '.menu-drawer__list-item--flat > ul > li > a::before{content:"";display:inline-block;width:6px;height:6px;border-radius:50%;background:var(--drawer-cat-color,#E8C758);margin-right:8px;flex-shrink:0;vertical-align:middle;}',
        '.menu-drawer__list-item--flat > a::after{content:"▾";font-size:16px;margin-left:8px;transition:transform .3s ease;opacity:.5;}',
        '.menu-drawer__list-item--flat.drawer-open > a::after{transform:rotate(180deg);opacity:.8;}',
        '.menu-drawer__list-item--flat.drawer-open > a{color:var(--drawer-cat-color,#E8C758)!important;}',
        '.menu-drawer__list-item--flat > a{cursor:pointer;}',
        /* IP sub-lists — yellow circle white arrow */
        '.ip-has-sub{flex-wrap:wrap!important;}',
        '.ip-has-sub > a{flex:1 1 auto;display:flex;align-items:center;}',
        '.ip-drawer-sublist{flex:0 0 100%;width:100%;max-height:0;overflow:hidden;transition:max-height .3s cubic-bezier(.4,0,.2,1);list-style:none;padding:0;margin:0;}',
        '.ip-sub-open > .ip-drawer-sublist{max-height:500px;}',
        '.ip-drawer-subitem{display:block;padding:6px 0 6px 24px;font-size:14px;color:#1A1A1F;text-decoration:none;opacity:.7;transition:opacity .15s;}',
        '.ip-drawer-subitem::before{content:"· ";font-weight:bold;color:var(--drawer-cat-color,#C94A3F);}',
        '.ip-drawer-subitem:active{opacity:1}',
        '.ip-drawer-seeall{display:block;padding:4px 0 4px 24px;font-size:12px;color:#999;text-decoration:none;}',
        ".ip-has-sub > a::after{content:'';display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:#FFD60A url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='10' viewBox='0 0 8 10'%3E%3Cpolygon points='0,0 8,5 0,10' fill='white'/%3E%3C/svg%3E\") no-repeat center/7px 9px;font-size:0;margin-left:auto;transition:transform .3s,background .2s;flex-shrink:0;}",
        '.ip-has-sub.ip-sub-open > a::after{transform:rotate(90deg);}',
        /* Brand drawer — full list built from BRAND_DATA */
        '.brand-drawer-list{list-style:none!important;padding:0!important;margin:0!important;flex:0 0 100%!important;width:100%!important;}',
        '.brand-drawer-list li{list-style:none!important;}',
        '.brand-drawer-list .brand-region-hdr{padding:8px 16px 4px;font-size:11px;letter-spacing:1px;color:#999;text-transform:uppercase;pointer-events:none;}',
        '.brand-drawer-list .brand-region-hdr::before{display:none!important;}',
        '.brand-maker-link{display:flex!important;align-items:center!important;flex:1 1 auto!important;padding:10px 16px!important;font-size:15px!important;color:#1A1A1F!important;text-decoration:none!important;}',
        '.brand-maker-link::before{display:none!important;}',
        /* Brand sub-lists — arrow cloned from Shopify theme IP arrow */
        '.brand-has-sub{display:flex!important;flex-wrap:wrap!important;width:100%!important;}',
        ".brand-has-sub > .brand-maker-link::after{content:'';display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:#FFD60A url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='10' viewBox='0 0 8 10'%3E%3Cpolygon points='0,0 8,5 0,10' fill='white'/%3E%3C/svg%3E\") no-repeat center/7px 9px;font-size:0;margin-left:auto;transition:transform .3s,background .2s;flex-shrink:0;}",
        '.brand-has-sub.brand-sub-open > .brand-maker-link::after{transform:rotate(90deg);}',
        '.brand-drawer-sublist{flex:0 0 100%;width:100%;max-height:0;overflow:hidden;transition:max-height .3s cubic-bezier(.4,0,.2,1);list-style:none;padding:0;margin:0;}',
        '.brand-sub-open > .brand-drawer-sublist{max-height:500px;}',
        '.brand-drawer-subitem{display:block;padding:6px 0 6px 24px;font-size:14px;color:#1A1A1F;text-decoration:none;opacity:.7;transition:opacity .15s;}',
        '.brand-drawer-subitem::before{content:"· ";font-weight:bold;color:var(--drawer-cat-color,#3B5BDB);}',
        '.brand-drawer-subitem:active{opacity:1}',
        '.brand-drawer-seeall{display:block;padding:4px 0 4px 24px;font-size:12px;color:#999;text-decoration:none;}'
      ].join('\n');
      document.head.appendChild(style);
    }

    function buildIPSubLists(ipLi) {
      if(ipLi.querySelectorAll('.ip-drawer-sublist').length) return;
      ipLi.querySelectorAll(':scope > ul > li').forEach(function(subLi){
        var link=subLi.querySelector(':scope > a'); if(!link) return;
        var href=link.getAttribute('href')||'';
        var handle=href.replace(/^https?:\/\/[^/]+/,'').replace('/collections/','').replace('/pages/','');
        var themeKey=HANDLE_TO_THEME[handle]; if(!themeKey) return;
        var ips=IP_BY_THEME[themeKey]; if(!ips||!ips.length) return;
        subLi.classList.add('ip-has-sub');
        var subList=document.createElement('ul'); subList.className='ip-drawer-sublist';
        ips.forEach(function(ip){
          var li=document.createElement('li'); var a=document.createElement('a');
          a.href='/collections/'+ip.handle;
          a.textContent=ip.name; a.className='ip-drawer-subitem'; li.appendChild(a); subList.appendChild(li);
        });
        var sli=document.createElement('li'); var sa=document.createElement('a');
        sa.href=href; sa.textContent='查看全部 →'; sa.className='ip-drawer-seeall';
        sli.appendChild(sa); subList.appendChild(sli); subLi.appendChild(subList);
      });
    }

    function rebuildBrandDrawer(brandLi) {
      if(brandLi.dataset.brandRebuilt) return;
      brandLi.dataset.brandRebuilt='1';
      /* Remove whatever Shopify nav originally put here */
      var oldUl=brandLi.querySelector(':scope > ul');
      if(oldUl) oldUl.remove();
      /* Build full brand list from BRAND_DATA — no inline styles, all via CSS */
      var ul=document.createElement('ul');
      ul.className='brand-drawer-list';
      BRAND_DATA.forEach(function(group){
        var hdrLi=document.createElement('li');
        hdrLi.className='brand-region-hdr';
        hdrLi.textContent=group.region;
        ul.appendChild(hdrLi);
        group.makers.forEach(function(maker){
          var li=document.createElement('li');
          var a=document.createElement('a');
          a.href='/collections/'+maker.handle;
          a.textContent=maker.name;
          a.className='brand-maker-link';
          li.appendChild(a);
          if(maker.subs.length){
            li.classList.add('brand-has-sub');
            var subList=document.createElement('ul');
            subList.className='brand-drawer-sublist';
            maker.subs.forEach(function(s){
              var sLi=document.createElement('li');
              var sA=document.createElement('a');
              sA.href='/collections/'+s.handle;
              sA.textContent=s.name;
              sA.className='brand-drawer-subitem';
              sLi.appendChild(sA);
              subList.appendChild(sLi);
            });
            var seeLi=document.createElement('li');
            var seeA=document.createElement('a');
            seeA.href='/collections/'+maker.handle;
            seeA.textContent='查看全部 →';
            seeA.className='brand-drawer-seeall';
            seeLi.appendChild(seeA);
            subList.appendChild(seeLi);
            li.appendChild(subList);
          }
          ul.appendChild(li);
        });
      });
      brandLi.appendChild(ul);
    }

    var delegationAttached=false;
    function attachDelegation(){
      if(delegationAttached) return;
      var drawer=document.querySelector('.menu-drawer'); if(!drawer) return;
      delegationAttached=true;
      drawer.addEventListener('click',function(e){
        var target=e.target.closest('a'); if(!target) return;
        var ipSub=target.closest('.ip-has-sub');
        if(ipSub){
          if(!target.closest('.ip-drawer-sublist')){
            e.preventDefault(); e.stopPropagation();
            var isOpen=ipSub.classList.contains('ip-sub-open');
            var catLi=ipSub.closest('.menu-drawer__list-item--flat');
            if(catLi){catLi.querySelectorAll('.ip-sub-open').forEach(function(el){el.classList.remove('ip-sub-open');});}
            if(!isOpen){ipSub.classList.add('ip-sub-open');}
          }
          return;
        }
        var brandSub=target.closest('.brand-has-sub');
        if(brandSub){
          if(!target.closest('.brand-drawer-sublist')){
            e.preventDefault(); e.stopPropagation();
            var isOpen=brandSub.classList.contains('brand-sub-open');
            var catLi=brandSub.closest('.menu-drawer__list-item--flat');
            if(catLi){catLi.querySelectorAll('.brand-sub-open').forEach(function(el){el.classList.remove('brand-sub-open');});}
            if(!isOpen){brandSub.classList.add('brand-sub-open');}
          }
          return;
        }
        var flatLi=target.closest('.menu-drawer__list-item--flat');
        if(flatLi && !target.closest('.menu-drawer__list-item--flat > ul')){
          e.preventDefault(); e.stopPropagation();
          var isOpen=flatLi.classList.contains('drawer-open');
          document.querySelectorAll('.menu-drawer__list-item--flat').forEach(function(o){
            o.classList.remove('drawer-open');
            o.querySelectorAll('.ip-sub-open').forEach(function(el){el.classList.remove('ip-sub-open');});
            o.querySelectorAll('.brand-sub-open').forEach(function(el){el.classList.remove('brand-sub-open');});
          });
          if(!isOpen){flatLi.classList.add('drawer-open');}
        }
      },true);
    }

    function wireDrawer(){
      var flatItems=document.querySelectorAll('.menu-drawer__list-item--flat');
      if(!flatItems.length) return false;
      flatItems.forEach(function(li){
        var heading=li.querySelector(':scope > a'); if(!heading) return;
        var catText=heading.textContent.trim();
        li.style.setProperty('--drawer-cat-color', CATEGORY_COLORS[catText]||'#E8C758');
        if(catText==='IP系列'){buildIPSubLists(li);}
        if(catText==='品牌'){rebuildBrandDrawer(li);}
      });
      attachDelegation();
      return true;
    }

    function boot(){
      injectStyles();
      var ok=wireDrawer();
      if(!ok){setTimeout(wireDrawer,500);setTimeout(wireDrawer,1500);setTimeout(wireDrawer,3000);}
      var details=document.querySelector('details.menu-drawer-container');
      if(details){details.addEventListener('toggle',function(){if(details.open){setTimeout(wireDrawer,50);}});}
    }

    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}
    else{boot();}
  })();

})();

/* Nav link jump prevention */
(function preventNavLinkJump(){
  'use strict';
  var TARGET_TEXTS=['產品分類','IP系列','品牌','預訂'];
  function intercept(sel){document.querySelectorAll(sel).forEach(function(a){if(TARGET_TEXTS.indexOf(a.textContent.trim())!==-1){a.addEventListener('click',function(e){e.preventDefault();});}});}
  function init(){intercept('.menu-list__link');intercept('.menu-drawer__menu-item--mainlist');}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
  else{init();}
})();